export default function (a, s = 2) {
    let g = [];
    for (let i = 0, l = a.length; i < l; i += s) {
        g.push(a.slice(i, i + s));
    }
    return g;
}